export type StudioNavItem = {
  slug: string;
  label: string;
  translationKey: string;
  icon: string;
  reloadDocument?: boolean;
};

export const studioNavigation: StudioNavItem[] = [
  // { slug: '', label: 'Home', translationKey: 'navigation.home', icon: 'home' },
  {
    slug: 'agent',
    label: 'Agent',
    translationKey: 'navigation.agent',
    icon: 'agent',
  },
  {
    slug: 'assets',
    label: 'Assets',
    translationKey: 'navigation.assets',
    icon: 'assets',
  },
  {
    slug: 'lab/launch',
    label: 'Mylo lab',
    translationKey: 'navigation.myloLab',
    icon: 'mylo-lab',
  },
];

export { agentSkills } from './agentSkills';

export type HomeShortcut =
  | {
      id: string;
      kind: 'skill';
      label: string;
      translationKey: string;
      skillId: string;
    }
  | {
      id: string;
      kind: 'prompt';
      label: string;
      translationKey: string;
      icon: string;
      text: string;
    }
  | {
      id: string;
      kind: 'skill-menu';
      label: string;
      translationKey: string;
      icon: string;
    };

export const homeShortcuts: HomeShortcut[] = [
  {
    id: 'edit-in-timeline',
    kind: 'skill',
    label: 'Edit in Timeline',
    translationKey: 'home.shortcuts.editTimeline',
    skillId: 'timeline',
  },
  {
    id: 'seedance-2-5',
    kind: 'skill',
    label: 'Мыло Video 2.5',
    translationKey: 'home.shortcuts.seedance',
    skillId: 'ad-video',
  },
  {
    id: 'doubao',
    kind: 'prompt',
    label: 'Doubao',
    translationKey: 'home.shortcuts.doubao',
    icon: 'image',
    text: 'Create an image with Doubao for [describe your idea].',
  },
  {
    id: 'ad-campaign',
    kind: 'skill',
    label: 'Ad Campaign',
    translationKey: 'home.shortcuts.adCampaign',
    skillId: 'ad-campaign',
  },
  {
    id: 'mood-board',
    kind: 'skill',
    label: 'Mood Board',
    translationKey: 'home.shortcuts.moodBoard',
    skillId: 'mood-board',
  },
  {
    id: 'all-skills',
    kind: 'skill-menu',
    label: 'All Skills',
    translationKey: 'home.allSkills',
    icon: 'list',
  },
];

export const useCaseTabs = [
  { label: 'Marketing campaigns', translationKey: 'home.tabs.marketing' },
  { label: 'Movies', translationKey: 'home.tabs.movies' },
  { label: 'Social media', translationKey: 'home.tabs.social' },
  { label: 'Educational content', translationKey: 'home.tabs.education' },
  { label: 'Experimental art', translationKey: 'home.tabs.experimental' },
  { label: 'Other', translationKey: 'home.tabs.other' },
];

export const quickPrompts = [
  {
    label: 'Adapt one idea for every platform',
    translationKey: 'home.presets.adapt',
    image: '/presets/adapt-platforms.jpg',
    position: 'object-center',
    width: 'sm:min-w-[236px]',
  },
  {
    label: 'Create a week of posts',
    translationKey: 'home.presets.posts',
    image: '/presets/week-of-posts.jpg',
    position: 'object-[center_28%]',
    width: 'sm:min-w-[214px]',
  },
  {
    label: 'Remix a trend with my product',
    translationKey: 'home.presets.remix',
    image: '/presets/remix-trend.jpg',
    position: 'object-[center_24%]',
    width: 'sm:min-w-[150px]',
  },
  {
    label: 'Generate a thumbnail pack',
    translationKey: 'home.presets.thumbnails',
    image: '/presets/thumbnail-pack.jpg',
    position: 'object-[center_62%]',
    width: 'sm:min-w-[388px]',
  },
  {
    label: 'Make a short vertical reel',
    translationKey: 'home.presets.reel',
    image: '/presets/vertical-reel.jpg',
    position: 'object-center',
    width: 'sm:min-w-[150px]',
  },
];

export const featuredItems = [
  {
    title: 'Aleph 2.0',
    description: 'Edit videos using keyframes.',
    cta: 'Try it now',
    gradient: 'from-violet-600/40 via-purple-900/60 to-black',
  },
  {
    title: 'Characters',
    description: 'Build real-time conversational video agents.',
    cta: 'Try it now',
    gradient: 'from-fuchsia-600/30 via-violet-900/60 to-black',
  },
  {
    title: 'Projects',
    description: 'Organize Sessions, Workflows and Assets in one place.',
    cta: 'Create Project',
    gradient: 'from-indigo-600/30 via-purple-900/60 to-black',
  },
  {
    title: 'Мыло Video 2.5',
    description:
      'Cinematic video generation with fine-grained control over duration, ratio, and audio.',
    cta: 'Try it now',
    gradient: 'from-purple-600/40 via-violet-950/70 to-black',
  },
];

export const appCategories = [
  'Film or shorts',
  'Marketing',
  'Social',
  'Educational content',
  'Experimental art',
];

export const starterApps = [
  {
    title: 'Edit Studio',
    description:
      'Use Aleph 2.0 to edit videos with natural language. Preview before you generate.',
    badge: 'NEW',
  },
  {
    title: 'Multi-Shot Video',
    description: 'Generate multi-shot videos from a single prompt.',
  },
  {
    title: 'Scene Builder',
    description:
      'Craft your multi-shot scene step by step — see the look, then bring it to life.',
  },
  {
    title: 'Upscale Video',
    description: 'Upscale video with Topaz AI.',
  },
  {
    title: 'Performance Capture with Act-Two',
    description: 'Animate characters using driving performance videos.',
  },
  {
    title: 'Remove from Video',
    description: 'Remove objects without reshooting.',
  },
];
